export default __webpack_public_path__ + "static/media/exit.a46967e4.svg";